import { render, staticRenderFns } from "./CashOnWay.vue?vue&type=template&id=3c804003"
import script from "./CashOnWay.vue?vue&type=script&lang=js"
export * from "./CashOnWay.vue?vue&type=script&lang=js"
import style0 from "./CashOnWay.vue?vue&type=style&index=0&id=3c804003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports